import {
  LOAD_SPARCLE_CARD,
  ON_PRESS_TOP_PRODUCT_DROPDOWN,
  ON_PRESS_REFERRALS_DROPDOWN,
  ON_PRESS_TOTAL_REVENUE_DROPDOWN,
  ON_PRESS_DATA_MANAGED_DROPDOWN,
  ON_PRESS_RECENT_CHAT_DROPDOWN,
  FACEBOOK_PROGRESS_BAR,
  TWITTER_PROGRESS_BAR,
  SEARCH_PROGRESS_BAR,
  AFFILIATES_PROGRESS_BAR,
  SET_SERVICE_BY_TYPES,
  SET_SERVICE_BY_STATUS,
  SET_AVERAGE_CHART_DATA,
  SET_COST_PRICE_DATA,
  SET_SERVICE_BY_BRANCH,
  SET_CUSTOMER_REVIEWS,
  SET_PROFIT_DATA,
  SET_RECEIVABLE_CHART_DATA,
  SET_SUPPLIER_DEBT_CHART_DATA,
  SET_DEBTS_CHART_DATA,
  SET_RECEIVABLE_CUSTOMER_PIE_CHART_DATA,
  SET_INCOME_EXPENSE_CHART_DATA,
  SET_INCOME_EXPENSE_PIE_CHART_DATA,
} from "../actions";

const initialState = {
  loadingPage: false,
  sparkleCardData: [],
  topProductDropDown: false,
  referralsDropDown: false,
  recentChatDropDown: false,
  totalRevenueDropDown: false,
  dataManagedDropDown: false,
  facebookShowProgressBar: 0,
  twitterShowProgressBar: 0,
  searchShowProgressBar: 0,
  affiliatesShowProgressBar: 0,
  serviceByTypes: [],
  serviceByStatus: [],
  averageChartData: [],
  costPriceData: [],
  profitData: [],
  serviceByBranch: [],
  customerReviewsData:[],
  receivablesChartData:[],
  debtsDataChart:[],
  receivablesCustomersChartData:[],
  supplierDebtsChartData:[],
  incomeExpenseChartData:[],
  incomeExpensePieChartData:[],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SPARCLE_CARD: {
      return {
        ...state,
        sparkleCardData: [...action.payload],
      };
    }
    case SET_SERVICE_BY_TYPES:
      return {
        ...state,
        serviceByTypes: action.payload,
      };

    case SET_SERVICE_BY_STATUS:
    return {
      ...state,
      serviceByStatus: action.payload,
    };
    case SET_CUSTOMER_REVIEWS:
    return {
      ...state,
      customerReviewsData: action.payload,
    };

    case SET_AVERAGE_CHART_DATA:
      return {
        ...state,
        averageChartData: action.payload
      };
      case SET_COST_PRICE_DATA:
      return {
        ...state,
        costPriceData: action.payload
      };
      case SET_RECEIVABLE_CHART_DATA:
      return {
        ...state,
        receivablesChartData: action.payload
      };
      case SET_SUPPLIER_DEBT_CHART_DATA:
      return {
        ...state,
        supplierDebtsChartData: action.payload
      };
      case SET_DEBTS_CHART_DATA:
      return {
        ...state,
        debtsDataChart: action.payload
      };
      case SET_INCOME_EXPENSE_CHART_DATA:
      return {
        ...state,
        incomeExpenseChartData: action.payload
      };
      case SET_INCOME_EXPENSE_PIE_CHART_DATA:
      return {
        ...state,
        incomeExpensePieChartData: action.payload
      };
      case SET_RECEIVABLE_CUSTOMER_PIE_CHART_DATA:
      return {
        ...state,
        receivablesCustomersChartData: action.payload
      };
      case SET_PROFIT_DATA:
      return {
        ...state,
        profitData: action.payload
      };
      case SET_SERVICE_BY_BRANCH:
      return {
        ...state,
        serviceByBranch: action.payload
      };

    case ON_PRESS_TOP_PRODUCT_DROPDOWN: {
      return {
        ...state,
        topProductDropDown: !state.topProductDropDown,
        recentChatDropDown: false,
        totalRevenueDropDown: false,
        dataManagedDropDown: false,
        referralsDropDown: false,
      };
    }

    case ON_PRESS_REFERRALS_DROPDOWN: {
      return {
        ...state,
        referralsDropDown: !state.referralsDropDown,
        topProductDropDown: false,
        recentChatDropDown: false,
        totalRevenueDropDown: false,
        dataManagedDropDown: false,
      };
    }

    case ON_PRESS_TOTAL_REVENUE_DROPDOWN: {
      return {
        ...state,
        totalRevenueDropDown: !state.totalRevenueDropDown,

        topProductDropDown: false,
        recentChatDropDown: false,
        dataManagedDropDown: false,
        referralsDropDown: false,
      };
    }

    case ON_PRESS_DATA_MANAGED_DROPDOWN: {
      return {
        ...state,
        dataManagedDropDown: !state.dataManagedDropDown,
        topProductDropDown: false,
        recentChatDropDown: false,
        totalRevenueDropDown: false,
        referralsDropDown: false,
      };
    }

    case ON_PRESS_RECENT_CHAT_DROPDOWN: {
      return {
        ...state,
        recentChatDropDown: !state.recentChatDropDown,
        topProductDropDown: false,
        totalRevenueDropDown: false,
        dataManagedDropDown: false,
        referralsDropDown: false,
      };
    }

    case FACEBOOK_PROGRESS_BAR: {
      return {
        ...state,
        facebookShowProgressBar: action.payload,
      };
    }

    case TWITTER_PROGRESS_BAR: {
      return {
        ...state,
        twitterShowProgressBar: action.payload,
      };
    }

    case AFFILIATES_PROGRESS_BAR: {
      return {
        ...state,
        affiliatesShowProgressBar: action.payload,
      };
    }

    case SEARCH_PROGRESS_BAR: {
      return {
        ...state,
        searchShowProgressBar: action.payload,
        loadingPage: false,
      };
    }

    default:
      return state;
  }
};
